import { MetaConversionsApiClient } from '@fourthwall/services/dist/MetaConversionsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteMetaConversionsMutation = createMutationHook(
  MetaConversionsApiClient.deletePixel,
  {
    mutationKey: ['metaConversionDelete'],
  },
)
